@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.float-label-container {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  line-height: 28px;
  background: @float-label--background-color;
  border-radius: 4px;
  &.slide-label-up {
    > label {
      top: 0;
      line-height: 20px;
      font-size: 10px;
    }
  }
  &.disabled {
    background: @float-label--disabled--border-color;
  }
  &.error {
    > label {
      color: @float-label--error--border-color;
    }
  }

  > label {
    position: absolute;
    padding: 0 10px;
    line-height: 40px;
    color: @float-label--text-color;
    transition: all 300ms ease;
  }
}
